
  import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
  import axios from 'axios';

  import draggable from 'vuedraggable';
  import MjButton from '@/components/mjml/mj-button.vue';
  import MjText from '@/components/mjml/mj-text.vue';
  import MjImage from '@/components/mjml/mj-image.vue';

  @Component({
    components: {
      MjButton,
      MjText,
      MjImage,
      draggable,
    },
  })
  export default class Generator extends Vue {
    public previewEditorLoading: boolean = false;
    @Prop({type: Array, default: () => []}) private propElements!: any;

    private elements: any = [
      {
        icon: 'format_align_left',
        name: 'Text',
        id: '1',
        type: 'mj-text',
        data: '<p>Beispieltext</p>',
        settings: {
          'padding-top': '10px',
          'padding-bottom': '10px',
          'padding-left': '25px',
          'padding-right': '25px',
        },
      },
      {
        icon: 'photo',
        name: 'Image',
        id: '3',
        type: 'mj-image',
        data: ' ',
        settings: {
          'padding-top': '0px',
          'padding-bottom': '0px',
          'padding-left': '0px',
          'padding-right': '0px',
          'width': '',
          'src': '',
        },
      },
      {
        icon: 'add_box',
        name: 'Button',
        id: '6',
        type: 'mj-button',
        data: 'Button',
        settings: {
          'padding-top': '0px',
          'padding-bottom': '0px',
          'padding-left': '0px',
          'padding-right': '0px',
          'background-color': '#414141',
          'href': '',
          'color': '#ffffff',
        },
      },
      {
        icon: 'add_box',
        name: 'Anmeldelink',
        id: '7',
        type: 'mj-button',
        data: 'Hier anmelden',
        settings: {
          'padding-top': '0px',
          'padding-bottom': '0px',
          'padding-left': '0px',
          'padding-right': '0px',
          'background-color': '#414141',
          'href': '##url##',
          'color': '#ffffff',
        },
      },
    ];

    private activeElements: any = [];
    private drag: boolean = false;
    private html: string = '';
    private activeTab: number = 0;
    private timeout: number | undefined = undefined;

    private insertComponent(obj) {
      const newEl = JSON.parse(JSON.stringify(obj));
      newEl.id = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      return newEl;
    }


    private deleteElement(index) {
      this.activeElements.splice(index, 1);
    }

    private updateElementSettings(index, settings) {
      this.activeElements[index].settings = settings;
      this.updateHtmlPreview();
    }

    private updateElementText(index, data) {
      this.activeElements[index].data = data;
      this.updateHtmlPreview();
    }

    private getMJML() {
      let mjml = '';
      this.activeElements.forEach((el) => {
        let settings = '';
        Object.keys(el.settings).forEach((key) => {
          settings += `${key}='${el.settings[key]}' `;
        });
        mjml += `<${el.type} ${settings}>${el.data}</${el.type}>`;
      });
      return `<mjml><mj-body><mj-section><mj-column width="600">${mjml}</mj-column></mj-section></mj-body></mjml>`;
    }

    private updateHtmlPreview() {
      this.previewEditorLoading = true;
      this.$emit('startLoading');
      window.clearTimeout(this.timeout);
      this.timeout = window.setTimeout(this.updateHtmlPreviewNow, 1500);
    }

    private updateHtmlPreviewNow() {
      const mjml = this.getMJML();
      axios.post(
        'https://api.mjml.io/v1/render',
        {mjml},
        {
          headers: {
            // eslint-disable-next-line max-len
            'Authorization': 'Basic MTdiYTc3MDEtYzFhYS00OGJhLTg0MDctNDQzNTA1YWU1ZDQzOjk2MWQxMWUwLTlkZGMtNDdlZC05NWM2' +
              'LTgyNTk1MWU2MGQxNA==',
            'Content-Type': 'application/json',
          },
        },
      ).then((res) => {
        // Strip height="auto" from <img> tags: Outlook for Windows (Word
        // rendering engine) does not understand it and collapses the image.
        const cleanedHtml = res.data.html.replace(
          /(<img\b[^>]*?)\s+height=["']auto["']/gi,
          '$1',
        );
        this.html = cleanedHtml;
        this.$emit('update', {html: cleanedHtml, mjml: res.data.mjml, object: this.activeElements});
        this.$emit('stopLoading');
        this.previewEditorLoading = false;
      });
    }

    @Watch('activeElements')
    private arrayUpdated() {
      this.updateHtmlPreview();
    }

    @Watch('propElements')
    private propUpdated() {
      this.activeElements = this.propElements;
    }
  }
